import React, { useState, useEffect } from 'react';
import { Check, X } from 'lucide-react';
import api from '../services/api';

const PreciosPlanesPage = () => {
  const [pricing, setPricing] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPricing();
  }, []);

  const loadPricing = async () => {
    try {
      const response = await api.get('/api/license-pricing/public');
      setPricing(response.data);
    } catch (error) {
      console.error('Error cargando precios:', error);
    } finally {
      setLoading(false);
    }
  };

  const plans = [
    {
      id: 'free',
      name: 'FREE',
      badge: 'INCLUIDO',
      badgeColor: 'bg-green-600',
      gradient: 'from-green-600 to-emerald-700',
      features: [
        { text: 'VPN', included: true },
        { text: 'Routers ilimitados', included: true },
        { text: 'Planes ilimitados', included: true },
        { text: 'Puntos de Venta ilimitados', included: true },
        { text: 'Vendedores ilimitados', included: true },
        { text: 'Impresión carta/ticket', included: true },
        { text: 'Cortes', included: true },
        { text: 'Reportes', included: true },
        { text: 'Gestión PPPoE', included: true },
        { text: 'Creador de Portales Cautivos', included: false },
        { text: 'Generador de Scripts', included: false },
        { text: 'Solución MAC aleatoria', included: false },
      ],
      subtitle: '30 DÍAS GRATIS'
    },
    {
      id: 'solo_vpn',
      name: 'SOLO VPN',
      gradient: 'from-blue-600 to-cyan-700',
      features: [
        { text: 'Acceso VPN', included: true },
        { text: 'Routers ilimitados', included: false },
        { text: 'Planes ilimitados', included: false },
        { text: 'Puntos de Venta ilimitados', included: false },
        { text: 'Vendedores ilimitados', included: false },
        { text: 'Impresión carta/ticket', included: false },
        { text: 'Cortes', included: false },
        { text: 'Reportes', included: false },
        { text: 'Gestión PPPoE', included: false },
        { text: 'Creador de Portales Cautivos', included: false },
        { text: 'Generador de Scripts', included: false },
        { text: 'Solución MAC aleatoria', included: false },
      ]
    },
    {
      id: 'solo_hotspot',
      name: 'SOLO HOTSPOT',
      gradient: 'from-blue-600 to-purple-700',
      features: [
        { text: 'VPN', included: true },
        { text: '1 Router', included: true },
        { text: 'Planes ilimitados', included: true },
        { text: 'Puntos de Venta ilimitados', included: true },
        { text: '3 Vendedores', included: true },
        { text: 'Impresión carta/ticket', included: true },
        { text: 'Cortes', included: true },
        { text: 'Reportes', included: true },
        { text: 'Gestión PPPoE', included: false },
        { text: 'Creador de Portales Cautivos', included: false },
        { text: 'Generador de Scripts', included: false },
        { text: 'Solución MAC aleatoria', included: false },
      ]
    },
    {
      id: 'solo_pppoe',
      name: 'SOLO PPPOE',
      gradient: 'from-blue-600 to-indigo-700',
      features: [
        { text: 'VPN', included: true },
        { text: '1 Router', included: true },
        { text: 'Cortes', included: true },
        { text: 'Reportes', included: true },
        { text: 'Gestión PPPoE', included: true },
        { text: 'Planes ilimitados', included: false },
        { text: 'Puntos de Venta ilimitados', included: false },
        { text: 'Vendedores ilimitados', included: false },
        { text: 'Impresión carta/ticket', included: false },
        { text: 'Creador de Portales Cautivos', included: false },
        { text: 'Generador de Scripts', included: false },
        { text: 'Solución MAC aleatoria', included: false },
      ]
    },
    {
      id: 'hotspot_pppoe',
      name: 'HOTSPOT + PPPOE',
      gradient: 'from-blue-600 to-blue-800',
      features: [
        { text: 'VPN', included: true },
        { text: '1 Router', included: true },
        { text: 'Planes ilimitados', included: true },
        { text: 'Puntos de Venta ilimitados', included: true },
        { text: '3 Vendedores', included: true },
        { text: 'Impresión carta/ticket', included: true },
        { text: 'Cortes', included: true },
        { text: 'Reportes', included: true },
        { text: 'Gestión PPPoE', included: true },
        { text: 'Creador de Portales Cautivos', included: false },
        { text: 'Generador de Scripts', included: false },
        { text: 'Solución MAC aleatoria', included: false },
      ]
    },
    {
      id: 'todo_incluido',
      name: 'TODO INCLUIDO',
      badge: 'POPULAR',
      badgeColor: 'bg-orange-500',
      gradient: 'from-pink-600 to-purple-700',
      features: [
        { text: 'VPN', included: true },
        { text: 'Routers ilimitados', included: true },
        { text: 'Planes ilimitados', included: true },
        { text: 'Puntos de Venta ilimitados', included: true },
        { text: 'Vendedores ilimitados', included: true },
        { text: 'Impresión carta/ticket', included: true },
        { text: 'Cortes', included: true },
        { text: 'Reportes', included: true },
        { text: 'Gestión PPPoE', included: true },
        { text: 'Creador de Portales Cautivos', included: true },
        { text: 'Generador de Scripts', included: true },
        { text: 'Solución MAC aleatoria', included: true },
      ]
    },
  ];

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Planes y Precios
          </h1>
          <p className="text-gray-400 text-lg">
            Elige el plan que mejor se adapte a tus necesidades
          </p>
        </div>

        {/* Plans Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className="bg-gray-800 rounded-2xl overflow-hidden shadow-2xl hover:scale-105 transition-transform duration-300"
            >
              {/* Header */}
              <div className={`bg-gradient-to-r ${plan.gradient} p-6 relative`}>
                {plan.badge && (
                  <span className={`absolute top-4 right-4 ${plan.badgeColor} text-white text-xs font-bold px-3 py-1 rounded-full`}>
                    {plan.badge}
                  </span>
                )}
                <h2 className="text-2xl font-bold text-center mb-2">{plan.name}</h2>
                {plan.subtitle && (
                  <p className="text-center text-sm opacity-90">{plan.subtitle}</p>
                )}
              </div>

              {/* Pricing */}
              <div className="p-6 border-b border-gray-700">
                {plan.id === 'free' ? (
                  <div className="text-center">
                    <p className="text-3xl font-bold text-green-400">GRATIS</p>
                    <p className="text-sm text-gray-400">30 días</p>
                  </div>
                ) : plan.id === 'todo_incluido' ? (
                  <div className="text-center">
                    <p className="text-sm text-gray-400 mb-1">Pago Único</p>
                    <p className="text-3xl font-bold text-yellow-400">
                      ${pricing?.[plan.id]?.lifetime?.toLocaleString() || 0} <span className="text-lg">MXN</span>
                    </p>
                  </div>
                ) : (
                  <div className="space-y-3">
                    <div className="text-center">
                      <p className="text-sm text-gray-400 mb-1">Mensual</p>
                      <p className="text-2xl font-bold text-cyan-400">
                        ${pricing?.[plan.id]?.monthly?.toLocaleString() || 0} <span className="text-sm">MXN/mes</span>
                      </p>
                    </div>
                    {pricing?.[plan.id]?.lifetime > 0 && (
                      <div className="text-center pt-3 border-t border-gray-700">
                        <p className="text-sm text-gray-400 mb-1">Pago Único</p>
                        <p className="text-2xl font-bold text-orange-400">
                          ${pricing?.[plan.id]?.lifetime?.toLocaleString() || 0} <span className="text-sm">MXN</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Features */}
              <div className="p-6 space-y-3">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    {feature.included ? (
                      <Check className="w-5 h-5 text-green-400 flex-shrink-0" />
                    ) : (
                      <X className="w-5 h-5 text-gray-600 flex-shrink-0" />
                    )}
                    <span className={feature.included ? 'text-white' : 'text-gray-600'}>
                      {feature.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Herramientas Section */}
        <div className="bg-gradient-to-r from-blue-600 to-cyan-700 rounded-2xl p-8 mb-8">
          <h2 className="text-3xl font-bold mb-6 text-center">🛠️ Módulo de Herramientas</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Incluye:</h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5" />
                  Generador de Portales Cautivos
                </li>
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5" />
                  Generador de Scripts
                </li>
                <li className="flex items-center gap-2">
                  <Check className="w-5 h-5" />
                  Solución a MAC aleatoria
                </li>
              </ul>
            </div>
            <div className="flex flex-col justify-center items-center bg-white/10 rounded-xl p-6">
              <p className="text-lg mb-2">Pago Único</p>
              <p className="text-4xl font-bold">
                ${pricing?.solo_herramientas?.lifetime?.toLocaleString() || 0} <span className="text-xl">MXN</span>
              </p>
            </div>
          </div>
        </div>

        {/* Adicionales Section */}
        <div className="bg-gradient-to-r from-pink-600 to-purple-700 rounded-2xl p-8">
          <h2 className="text-3xl font-bold mb-6 text-center">➕ Adicionales</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gray-700 rounded-xl p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">Router Adicional</h3>
              <p className="text-3xl font-bold text-cyan-400">
                ${pricing?.extra_router_cost || 0} <span className="text-lg">MXN/mes</span>
              </p>
            </div>
            <div className="bg-gray-700 rounded-xl p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">Vendedor Adicional</h3>
              <p className="text-3xl font-bold text-green-400">
                ${pricing?.extra_seller_cost || 0} <span className="text-lg">MXN/mes</span>
              </p>
            </div>
          </div>
          <p className="text-center text-gray-400 mt-6 text-sm">
            * Por defecto cada router incluye {pricing?.sellers_per_router || 3} vendedores
          </p>
        </div>

        {/* Footer */}
        <div className="text-center mt-12 text-gray-400">
          <p>Todos los precios son en Pesos Mexicanos (MXN)</p>
          <p className="mt-2 text-sm">Los precios están sujetos a cambios sin previo aviso</p>
        </div>
      </div>
    </div>
  );
};

export default PreciosPlanesPage;
